import { useEffect, useRef } from 'react';
import { io } from 'socket.io-client';

// In production: REACT_APP_API_URL is set to the backend domain (e.g. https://api.yourdomain.com)
// In local dev:  REACT_APP_API_URL is empty and the React proxy handles /api/* HTTP requests,
//               but the proxy does NOT handle WebSocket connections.
//               socket.io must connect directly to the backend port.
const BASE_URL = process.env.REACT_APP_API_URL || 'http://localhost:5123';

let sharedSocket = null;
let refCount = 0;

/**
 * Returns a shared socket.io connection authenticated with the user's JWT.
 * The connection is created once and reused across all hook consumers.
 * It is disconnected when the last consumer unmounts.
 */
export function useSocket() {
  const socketRef = useRef(null);

  useEffect(() => {
    const token = localStorage.getItem('mv_token');
    if (!token) return;

    // Reuse the shared socket if already connected
    if (!sharedSocket || !sharedSocket.connected) {
      sharedSocket = io(BASE_URL, {
        auth: { token },
        transports: ['websocket', 'polling'],
        reconnectionAttempts: 5,
        reconnectionDelay: 2000,
      });
    }

    refCount++;
    socketRef.current = sharedSocket;

    return () => {
      refCount--;
      if (refCount <= 0 && sharedSocket) {
        sharedSocket.disconnect();
        sharedSocket = null;
        refCount = 0;
      }
    };
  }, []);

  return socketRef.current;
}
